/* ==========================================================================
   Skin Theory · Warenkorb-Drawer
   Rabattcodes über die Cart-AJAX-API (/cart/update.js, discount-Parameter)
   und Kleinkram wie das Auf-/Zuklappen des Code-Felds.

   Alles läuft über Event-Delegation: Dawn ersetzt bei jeder Mengenänderung
   das komplette innerHTML von .drawer__inner, direkt gebundene Listener
   wären danach weg.
   ========================================================================== */

(function () {
  // null = noch nicht angetippt: dann gilt, was Liquid und CSS vorgeben (offen,
  // auf kurzen Handy-Bildschirmen zu, mit eingelöstem Code immer offen).
  var discountOpen = null;

  function drawerInner() {
    return document.querySelector('#CartDrawer .drawer__inner');
  }

  function sectionInnerHTML(html, selector) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var el = doc.querySelector(selector);
    return el ? el.innerHTML : null;
  }

  function renderSections(sections) {
    if (!sections) return;

    if (sections['cart-drawer']) {
      var inner = sectionInnerHTML(sections['cart-drawer'], '.drawer__inner');
      var target = drawerInner();
      if (inner !== null && target) target.innerHTML = inner;
    }

    if (sections['cart-icon-bubble']) {
      var bubble = document.getElementById('cart-icon-bubble');
      if (bubble) {
        var bubbleInner = sectionInnerHTML(sections['cart-icon-bubble'], '.shopify-section');
        if (bubbleInner !== null) {
          (bubble.querySelector('.shopify-section') || bubble).innerHTML = bubbleInner;
        }
      }
    }

    var cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer) cartDrawer.classList.toggle('is-empty', !document.querySelector('.cart-item'));

    restoreDiscountState();
  }

  function restoreDiscountState() {
    var block = document.querySelector('[data-st-disc]');
    if (!block) return;
    if (discountOpen === null) return;
    block.classList.toggle('is-closed', !discountOpen);
    block.classList.toggle('is-open', discountOpen);
  }

  function appliedCodes() {
    var block = document.querySelector('[data-st-disc]');
    if (!block || !block.dataset.stCodes) return [];
    return block.dataset.stCodes.split(',').filter(Boolean);
  }

  function showError(message) {
    var box = document.querySelector('[data-st-disc-error]');
    if (box) box.textContent = message || '';
  }

  function setBusy(busy) {
    var btn = document.querySelector('[data-st-disc-apply]');
    if (btn) btn.setAttribute('aria-busy', busy ? 'true' : 'false');
  }

  /* Schickt die komplette Code-Liste an Shopify. Leerer String = alle entfernen. */
  function pushDiscounts(codes) {
    return fetch(window.routes.cart_update_url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        discount: codes.join(','),
        sections: 'cart-drawer,cart-icon-bubble',
        sections_url: window.location.pathname,
      }),
    }).then(function (response) {
      return response.json();
    });
  }

  function isApplied(cart, code) {
    var list = cart && cart.discount_codes;
    if (!list) return false;
    var wanted = code.toUpperCase();
    for (var i = 0; i < list.length; i++) {
      if (String(list[i].code).toUpperCase() === wanted) {
        return list[i].applicable !== false;
      }
    }
    return false;
  }

  function applyCode(code) {
    var existing = appliedCodes().filter(function (c) {
      return c.toUpperCase() !== code.toUpperCase();
    });
    var next = existing.concat([code]);

    setBusy(true);
    showError('');

    pushDiscounts(next)
      .then(function (cart) {
        if (isApplied(cart, code)) {
          renderSections(cart.sections);
          return;
        }
        // Code greift nicht: sauber wieder entfernen und Fehler zeigen.
        return pushDiscounts(existing).then(function (reverted) {
          renderSections(reverted.sections);
          showError('Dieser Code ist nicht gültig oder nicht mit deinem aktuellen Rabatt kombinierbar.');
        });
      })
      .catch(function () {
        showError('Das hat gerade nicht geklappt. Bitte noch einmal versuchen.');
      })
      .finally(function () {
        setBusy(false);
      });
  }

  function removeCode(code) {
    var next = appliedCodes().filter(function (c) {
      return c.toUpperCase() !== code.toUpperCase();
    });

    showError('');
    pushDiscounts(next)
      .then(function (cart) {
        renderSections(cart.sections);
      })
      .catch(function () {
        showError('Das hat gerade nicht geklappt. Bitte noch einmal versuchen.');
      });
  }

  function submitFromInput() {
    var input = document.querySelector('[data-st-disc-input]');
    if (!input) return;
    var code = input.value.trim();
    if (!code) {
      input.focus();
      return;
    }
    input.value = '';
    applyCode(code);
  }

  /* --------------------------------------------------------------------
     Sofort-Anzeige

     Der Server braucht für eine Mengenänderung gut eine halbe Sekunde, auf
     dem Handy mehr. Zeilenpreis, Summe, Zähler und Versandbalken werden
     deshalb direkt beim Klick aus den Stückpreisen neu gerechnet; die
     Serverantwort ersetzt danach den ganzen Drawer. Nur aktiv, wenn der
     Server data-st-money liefert (keine Rabatte, Shop-Währung).
     -------------------------------------------------------------------- */

  function formatMoney(cents, format) {
    var value = '';
    var match = format.match(/\{\{\s*(\w+)\s*\}\}/);
    if (!match) return null;

    function withDelimiters(number, precision, thousands, decimal) {
      var fixed = (number / 100).toFixed(precision);
      var parts = fixed.split('.');
      var whole = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + thousands);
      return parts[1] ? whole + decimal + parts[1] : whole;
    }

    switch (match[1]) {
      case 'amount':
        value = withDelimiters(cents, 2, ',', '.');
        break;
      case 'amount_no_decimals':
        value = withDelimiters(cents, 0, ',', '.');
        break;
      case 'amount_with_comma_separator':
        value = withDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = withDelimiters(cents, 0, '.', ',');
        break;
      case 'amount_with_apostrophe_separator':
        value = withDelimiters(cents, 2, "'", '.');
        break;
      default:
        return null;
    }
    return format.replace(match[0], value);
  }

  function lineQuantity(item) {
    if (item.hasAttribute('data-st-removing')) return 0;
    if (item.hasAttribute('data-st-qty')) return parseInt(item.getAttribute('data-st-qty'), 10) || 0;
    var input = item.querySelector('.quantity__input');
    return input ? Math.max(0, parseInt(input.value, 10) || 0) : null;
  }

  function applyOptimistic() {
    var ship = document.querySelector('#CartDrawer .st-ship');
    var format = ship && ship.getAttribute('data-st-money');
    if (!format || formatMoney(0, format) === null) return;

    var items = document.querySelectorAll('#CartDrawer .cart-item');
    var total = 0;
    var count = 0;

    // Gratis-Spatel: gratis nur, solange noch Body Butter im Warenkorb bleibt.
    // Bleibt außer ihm nichts übrig, verschwindet er mit; sonst kostet er den Einzelpreis.
    var tubsLeft = false;
    var othersLeft = false;
    // Geschenk-Lip-Balm: bleibt nur, solange ein 3er-Set im Warenkorb liegt.
    var threeLeft = false;
    for (var t = 0; t < items.length; t++) {
      if (items[t].hasAttribute('data-st-gift') || items[t].hasAttribute('data-st-giftlip') || !(lineQuantity(items[t]) > 0)) continue;
      othersLeft = true;
      if (items[t].hasAttribute('data-st-tub')) tubsLeft = true;
      if (items[t].hasAttribute('data-st-three')) threeLeft = true;
    }

    for (var i = 0; i < items.length; i++) {
      var price = items[i].querySelector('[data-st-unit]');
      var qty = lineQuantity(items[i]);
      if (!price || qty === null) return;

      if (items[i].hasAttribute('data-st-giftlip')) {
        items[i].classList.toggle('st-item--leaving', !threeLeft);
        if (threeLeft) count += qty;
        continue;
      }

      if (items[i].hasAttribute('data-st-gift')) {
        var value = parseInt(price.getAttribute('data-st-ref-unit'), 10) || 0;
        var note = items[i].querySelector('.st-gift__note');
        items[i].classList.toggle('st-item--leaving', !othersLeft);
        if (!othersLeft) continue;
        price.innerHTML = tubsLeft
          ? formatMoney(0, format) + '<s>' + formatMoney(value, format) + '</s>'
          : formatMoney(value, format);
        if (note) note.hidden = !tubsLeft;
        if (!tubsLeft) total += value;
        count += 1;
        continue;
      }

      var unit = parseInt(price.getAttribute('data-st-unit'), 10) || 0;
      var refUnit = parseInt(price.getAttribute('data-st-ref-unit'), 10) || unit;
      var line = unit * qty;
      var ref = refUnit * qty;
      price.innerHTML = formatMoney(line, format) + (ref > line ? '<s>' + formatMoney(ref, format) + '</s>' : '');
      items[i].classList.toggle('st-item--leaving', qty === 0);

      total += line;
      count += qty;
    }

    var totalEl = document.querySelector('#CartDrawer .st-row--total .st-row__value');
    if (totalEl) totalEl.textContent = formatMoney(total, format);

    var countEl = document.querySelector('#CartDrawer .st-head__count');
    if (countEl) countEl.textContent = '(' + count + ')';

    var threshold = parseInt(ship.getAttribute('data-st-threshold'), 10) || 0;
    if (!threshold) return;
    var remaining = threshold - total;
    var progress = Math.min(100, Math.floor((total * 100) / threshold));
    var text = ship.querySelector('.st-ship__text');
    var fill = ship.querySelector('.st-ship__fill');
    var truck = ship.querySelector('.st-ship__truck');

    ship.classList.toggle('st-ship--done', remaining <= 0);
    if (fill) fill.style.width = progress + '%';
    if (truck) truck.style.left = progress + '%';
    if (text) {
      text.innerHTML =
        remaining <= 0
          ? '<b>Versand geschenkt</b> – du hast die ' + ship.getAttribute('data-st-threshold-label') + ' erreicht'
          : 'Nur noch <span class="st-ship__amount">' + formatMoney(remaining, format) + '</span> bis zum <b>kostenlosen Versand</b>';
    }
  }

  /* Lehnt der Server eine Menge ab (z. B. Bestand), setzt Dawn nur das Mengenfeld
     zurück und rendert nichts neu. Sobald die Ladesperre fällt, deshalb noch einmal
     aus den Mengenfeldern rechnen, damit keine vorab gezeigte Zahl stehen bleibt. */
  var watchingLoad = false;

  function watchLoadingEnd() {
    var drawer = document.getElementById('CartDrawer');
    if (watchingLoad || !drawer || !window.MutationObserver) return;
    watchingLoad = true;
    new MutationObserver(function (records) {
      for (var i = 0; i < records.length; i++) {
        var target = records[i].target;
        var was = records[i].oldValue || '';
        if (
          target.id === 'CartDrawer-CartItems' &&
          was.indexOf('cart__items--disabled') !== -1 &&
          !target.classList.contains('cart__items--disabled')
        ) {
          applyOptimistic();
          return;
        }
      }
    }).observe(drawer, { attributes: true, attributeFilter: ['class'], attributeOldValue: true, subtree: true });
  }

  // Plus/Minus bzw. getippte Menge: Dawn feuert 'change' am Input und schickt erst nach dem Debounce.
  document.addEventListener('change', function (event) {
    if (event.target.matches && event.target.matches('#CartDrawer .quantity__input')) applyOptimistic();
  });

  // Entfernen: Dawn schickt sofort, die Zeile blendet schon vorher aus.
  document.addEventListener(
    'click',
    function (event) {
      var remove = event.target.closest && event.target.closest('#CartDrawer cart-remove-button');
      if (!remove) return;
      var item = remove.closest('.cart-item');
      if (item) item.setAttribute('data-st-removing', '');
      applyOptimistic();
    },
    true
  );

  /* --------------------------------------------------------------------
     Upsell im Drawer: per /cart/add.js hinzufügen und den
     Drawer aus den mitgelieferten Sections neu zeichnen.
     -------------------------------------------------------------------- */

  function escapeHtml(text) {
    var div = document.createElement('div');
    div.textContent = text || '';
    return div.innerHTML;
  }

  /* Platzhalter-Zeile, bis die Serverantwort da ist. Gleicher Aufbau wie eine
     echte Position aus cart-drawer.liquid (Mengenfeld, Entfernen, Lagerhinweis),
     damit beim Austausch nichts nachwächst oder springt. Normale Elemente statt
     quantity-input/cart-remove-button: Dawn soll darauf nicht reagieren. */
  var ICON_MINUS = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true"><path d="M5 12h14" /></svg>';
  var ICON_PLUS = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true"><path d="M12 5v14M5 12h14" /></svg>';
  var ICON_CHECK = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M20 6L9 17l-5-5" /></svg>';

  function insertPendingLine(block) {
    var list = document.querySelector('#CartDrawer .st-items');
    if (!list) return;
    var variant = block.getAttribute('data-st-variant');
    var img = block.getAttribute('data-st-img');
    var line = document.createElement('div');
    line.className = 'cart-item st-item--pending';
    line.setAttribute('data-st-qty', '1');
    line.setAttribute('aria-hidden', 'true');
    line.innerHTML =
      '<div class="cart-item__media">' +
      (img ? '<img class="cart-item__image" src="' + escapeHtml(img) + '" alt="" width="150">' : '') +
      '</div>' +
      '<div class="cart-item__details">' +
      // Leerer Spinner wie in der echten Position: Dawns Abstandsregel (> * + *) greift sonst anders.
      '<div class="loading__spinner hidden"></div>' +
      '<div class="st-item__top"><div>' +
      '<span class="cart-item__name">' + escapeHtml(block.getAttribute('data-st-title')) + '</span>' +
      (variant ? '<p class="st-item__variant">' + escapeHtml(variant) + '</p>' : '') +
      '</div><div class="st-item__price" data-st-unit="' + escapeHtml(block.getAttribute('data-st-price')) +
      '" data-st-ref-unit="' + escapeHtml(block.getAttribute('data-st-compare')) + '"></div></div>' +
      '<div class="st-item__bottom">' +
      '<div class="quantity st-qty">' +
      '<button class="quantity__button" type="button" tabindex="-1">' + ICON_MINUS + '</button>' +
      '<input class="quantity__input" type="number" value="1" readonly tabindex="-1">' +
      '<button class="quantity__button" type="button" tabindex="-1">' + ICON_PLUS + '</button>' +
      '</div>' +
      '<button type="button" class="st-remove" tabindex="-1">Entfernen</button>' +
      '</div>' +
      '<p class="st-item__note">' + ICON_CHECK + 'Auf Lager · in 1–2 Tagen bei dir</p>' +
      '</div>';
    // Shopify setzt neue Artikel oben ein – Platzhalter an dieselbe Stelle, sonst springt er.
    list.insertBefore(line, list.firstChild);
  }

  function addUpsell(button) {
    if (button.getAttribute('aria-busy') === 'true') return;
    var block = button.closest('[data-st-upsell]');
    button.setAttribute('aria-busy', 'true');

    if (block) {
      insertPendingLine(block);
      block.hidden = true;
      applyOptimistic();
    }

    var variantId = Number(button.getAttribute('data-st-upsell-add'));

    fetch(window.routes.cart_add_url + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [{ id: variantId, quantity: 1 }],
        sections: 'cart-drawer,cart-icon-bubble',
        sections_url: window.location.pathname,
      }),
    })
      .then(function (response) {
        return response.json().then(function (data) {
          if (!response.ok || data.status) throw data;
          return data;
        });
      })
      .then(function (data) {
        // Die Antwort bringt Drawer und Zähler schon mit. Kein cartUpdate-Publish:
        // Dawn würde sonst den Drawer ein zweites Mal laden und neu zeichnen.
        renderSections(data.sections);
        // Body Butter per Upsell: Gratis-Spatel anlegen bzw. den normalen Spatel umstellen.
        checkCart();
      })
      .catch(function (data) {
        var message = (data && data.description) || 'Das hat gerade nicht geklappt. Bitte noch einmal versuchen.';
        refreshDrawer().then(function () {
          var error = document.querySelector('#CartDrawer [data-st-upsell-error]');
          if (error) error.textContent = message;
        });
      });
  }

  /* --------------------------------------------------------------------
     Warenkorb-Regeln, ausgelöst beim Laden, bei jedem cartUpdate aus Dawns
     Pubsub und beim Öffnen des Drawers:

     1. Gratis-Spatel: Mit Body Butter liegt genau ein "Edelstahl-Spatel ·
        gratis dazu" (0 €) im Warenkorb. Hat der Kunde schon einen normalen
        Spatel drin, wird einer davon zum Gratis-Spatel. Ohne Body Butter
        wird der Gratis-Spatel gegen den normalen Spatel (8,90 €) getauscht.
     2. Set-Preis: "Tallow Lip Balm · im Set" gibt es nur zusammen mit Body
        Butter. Ohne sie wird der Set-Stift gegen den Einzelstift im selben
        Duft getauscht.

     3. Geschenk-Lip-Balm (Angebot B): nur zusammen mit dem 3er-Set, höchstens
        einer. Fliegt das 3er-Set raus, fliegt der Stift mit raus.

     Alle Korrekturen gehen in einer einzigen /cart/update.js-Anfrage raus.
     -------------------------------------------------------------------- */

  var SET_LIP = 'tallow-lip-balm-im-set';
  var SINGLE_LIP = 'tallow-lip-balm';
  var GIFT = 'edelstahl-spatel-gratis-dazu';
  var SPATULA = 'hochwertiger-edelstahl-spatel';
  var TUB_HANDLES = ['tallow-body-butter', 'vanilla-body-butter-2-tiegel', 'vanilla-body-butter-3-tiegel'];
  // Geschenk-Lip-Balm (Angebot B): kommt nur mit dem 3er-Set über product.angebot-b in den Warenkorb.
  var GIFT_LIP = 'tallow-lip-balm-geschenkt';
  var THREE = 'vanilla-body-butter-3-tiegel';
  var fixing = false;
  // Gratis-Spatel ließ sich nicht anlegen (z. B. ausverkauft): auf dieser Seite nicht erneut versuchen.
  var giftFailed = false;

  var NOTE_SET = 'Den Set-Preis gibt es nur zusammen mit der Body Butter. Dein Lip Balm liegt jetzt zum Einzelpreis im Warenkorb.';
  var NOTE_SPATULA = 'Den Spatel gibt es nur zusammen mit der Body Butter gratis. Er liegt jetzt zum Einzelpreis im Warenkorb.';
  var NOTE_BOTH = 'Set-Preis und Gratis-Spatel gibt es nur zusammen mit der Body Butter. Lip Balm und Spatel liegen jetzt zum Einzelpreis im Warenkorb.';

  function showNote(text) {
    var list = document.querySelector('#CartDrawer .st-items');
    if (!list || !text) return;
    var note = list.querySelector('.st-setnote');
    if (!note) {
      note = document.createElement('p');
      note.className = 'st-setnote';
      note.setAttribute('role', 'status');
      list.insertBefore(note, list.firstChild);
    }
    note.textContent = text;
  }

  function quantityOf(cart, handle) {
    return cart.items.reduce(function (sum, item) {
      return item.handle === handle ? sum + item.quantity : sum;
    }, 0);
  }

  function variantId(name) {
    var drawer = document.querySelector('cart-drawer');
    return (drawer && Number(drawer.getAttribute(name))) || 0;
  }

  function setBusyItems(busy) {
    var items = document.getElementById('CartDrawer-CartItems');
    if (items) items.classList.toggle('st-items--busy', busy);
  }

  function fixCart(cart) {
    if (!cart || !cart.items) return;
    // Dawn setzt is-empty nach der Artikelzahl; zählt nur noch der Gratis-Spatel, ist der Drawer schon leer.
    var cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer && cart.item_count > 0) cartDrawer.classList.toggle('is-empty', !document.querySelector('#CartDrawer .cart-item'));
    var updates = {};
    var notes = [];
    var addsGift = false;
    var hasTub = cart.items.some(function (item) {
      return TUB_HANDLES.indexOf(item.handle) !== -1;
    });

    var giftId = variantId('data-st-gift-variant');
    var spatulaId = variantId('data-st-spatula-variant');
    var giftQty = quantityOf(cart, GIFT);
    var spatulaQty = quantityOf(cart, SPATULA);

    // 3. Geschenk-Lip-Balm: höchstens einer, und nur zusammen mit dem 3er-Set.
    var giftLipId = variantId('data-st-giftlip-variant');
    var giftLipQty = quantityOf(cart, GIFT_LIP);
    var giftLipOrphan = 0;
    if (giftLipId && giftLipQty > 0) {
      if (quantityOf(cart, THREE) === 0) {
        updates[giftLipId] = 0;
        giftLipOrphan = giftLipQty;
      } else if (giftLipQty > 1) {
        updates[giftLipId] = 1;
      }
    }

    if (giftId && spatulaId) {
      if (hasTub && giftQty === 0 && !giftFailed) {
        updates[giftId] = 1;
        if (spatulaQty > 0) updates[spatulaId] = spatulaQty - 1;
        addsGift = true;
      } else if (hasTub && giftQty > 1) {
        updates[giftId] = 1;
      } else if (!hasTub && giftQty > 0) {
        updates[giftId] = 0;
        // Liegt sonst nichts mehr im Warenkorb, hat den Spatel niemand gewählt: ganz raus.
        if (cart.item_count > giftQty + giftLipOrphan) {
          updates[spatulaId] = spatulaQty + 1;
          notes.push(NOTE_SPATULA);
        }
      }
    }

    var sets = hasTub
      ? []
      : cart.items.filter(function (item) {
          return item.handle === SET_LIP;
        });

    if (!sets.length && !Object.keys(updates).length) return;

    fixing = true;
    setBusyItems(true);
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var ready = sets.length
      ? fetch(root + 'products/' + SINGLE_LIP + '.js')
          .then(function (response) {
            return response.json();
          })
          .then(function (product) {
            sets.forEach(function (set) {
              var single =
                product.variants.filter(function (v) {
                  return v.title === set.variant_title;
                })[0] || product.variants[0];
              if (updates[single.id] === undefined) {
                updates[single.id] = cart.items
                  .filter(function (item) {
                    return item.variant_id === single.id;
                  })
                  .reduce(function (sum, item) {
                    return sum + item.quantity;
                  }, 0);
              }
              updates[single.id] += set.quantity;
              updates[set.variant_id] = 0;
            });
            notes.unshift(NOTE_SET);
          })
      : Promise.resolve();

    var retry = false;

    return ready
      .then(function () {
        return fetch(window.routes.cart_update_url, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            updates: updates,
            sections: 'cart-drawer,cart-icon-bubble',
            sections_url: window.location.pathname,
          }),
        });
      })
      .then(function (response) {
        return response.json().then(function (data) {
          if (!response.ok || !data.items) throw data;
          return data;
        });
      })
      .then(function (data) {
        // Warenkorbseite rendert ihre eigenen Sections: dort einfach neu laden.
        if (window.location.pathname === window.routes.cart_url) {
          window.location.reload();
          return;
        }
        renderSections(data.sections);
        showNote(notes.length > 1 ? NOTE_BOTH : notes[0]);
        return data;
      })
      .catch(function () {
        if (addsGift) {
          giftFailed = true;
          retry = true;
          var pending = document.querySelector('#CartDrawer [data-st-gift-pending]');
          if (pending) pending.remove();
          applyOptimistic();
        }
      })
      .finally(function () {
        fixing = false;
        setBusyItems(false);
        // Ohne den Gratis-Spatel noch einmal: die übrigen Korrekturen sollen trotzdem greifen.
        if (retry) fixCart(cart);
      });
  }

  /* Zur Kasse, während der Gratis-Spatel noch nicht angelegt ist (Klick direkt nach dem
     Öffnen): erst die Regeln durchlaufen lassen, dann weiter. Sonst fehlt er in der
     Bestellung und der Bestand stimmt nicht. */
  function checkoutWhenReady(event) {
    var button = event.target.closest && event.target.closest('#CartDrawer-Checkout');
    if (!button) return;
    var pending = document.querySelector('#CartDrawer [data-st-gift-pending], #CartDrawer .st-items--busy');
    if (!pending && !fixing) return;
    event.preventDefault();
    button.setAttribute('aria-busy', 'true');
    var go = function () {
      window.location.href = '/checkout';
    };
    var started = Date.now();
    (function wait() {
      if (fixing && Date.now() - started < 4000) return setTimeout(wait, 100);
      fetch(window.routes.cart_url + '.js', { headers: { Accept: 'application/json' } })
        .then(function (response) {
          return response.json();
        })
        .then(function (cart) {
          return fixCart(cart);
        })
        .then(go, go);
    })();
  }

  document.addEventListener('click', checkoutWhenReady, true);

  function checkCart(event) {
    if (fixing) return;
    // Dawn liefert nach Mengenänderungen den neuen Warenkorb gleich mit.
    if (event && event.cartData && event.cartData.items && event.cartData.item_count !== undefined) {
      fixCart(event.cartData);
      return;
    }
    fetch(window.routes.cart_url + '.js', { headers: { Accept: 'application/json' } })
      .then(function (response) {
        return response.json();
      })
      .then(fixCart)
      .catch(function () {});
  }

  function watchCartUpdates() {
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
    subscribe(PUB_SUB_EVENTS.cartUpdate, checkCart);
    // Dawn ersetzt den Drawer nach Mengenänderungen: angetippten Zustand des Code-Felds halten.
    subscribe(PUB_SUB_EVENTS.cartUpdate, restoreDiscountState);
  }

  document.addEventListener('click', function (event) {
    var target = event.target;

    var upsellAdd = target.closest('[data-st-upsell-add]');
    if (upsellAdd) {
      event.preventDefault();
      addUpsell(upsellAdd);
      return;
    }

    if (target.closest('[data-st-disc-apply]')) {
      event.preventDefault();
      submitFromInput();
      return;
    }

    var chip = target.closest('[data-st-chip-remove]');
    if (chip) {
      event.preventDefault();
      removeCode(chip.getAttribute('data-st-chip-remove'));
      return;
    }

    if (target.closest('[data-st-disc-toggle]')) {
      event.preventDefault();
      var form = document.querySelector('[data-st-disc] .st-disc__form');
      discountOpen = !(form && getComputedStyle(form).display !== 'none');
      restoreDiscountState();
      return;
    }

    if (target.closest('[data-st-close]')) {
      event.preventDefault();
      var drawer = target.closest('cart-drawer');
      if (drawer) drawer.close();
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Enter') return;
    if (!event.target.matches || !event.target.matches('[data-st-disc-input]')) return;
    event.preventDefault();
    submitFromInput();
  });

  /* --------------------------------------------------------------------
     Abgleich beim Öffnen

     Fremd-Apps (Kaching Bundles) legen Artikel selbst per /cart/add.js an
     und öffnen danach den Drawer, ohne dessen Inhalt neu zu rendern – der
     Drawer zeigt dann den Stand von vor dem Klick. Beim Öffnen deshalb
     gegen /cart.js prüfen und bei Abweichung die Sections nachladen.
     -------------------------------------------------------------------- */

  function renderedItemCount() {
    var total = 0;
    document.querySelectorAll('#CartDrawer .cart-item:not([data-st-gift]) .quantity__input').forEach(function (input) {
      // value-Attribut = Stand beim Rendern. input.value zählt schon den Klick mit,
      // der noch unterwegs ist, und hätte sonst einen veralteten Neuaufbau ausgelöst.
      total += parseInt(input.getAttribute('value'), 10) || 0;
    });
    // Gratis-Spatel hat kein Mengenfeld. Die vorab gezeigte Zeile zählt noch nicht.
    document.querySelectorAll('#CartDrawer [data-st-gift]:not([data-st-gift-pending])').forEach(function (line) {
      total += parseInt(line.getAttribute('data-st-qty'), 10) || 0;
    });
    return total;
  }

  function refreshDrawer() {
    return fetch(window.routes.cart_url + '?sections=cart-drawer,cart-icon-bubble')
      .then(function (response) {
        return response.json();
      })
      .then(renderSections)
      .catch(function () {});
  }

  function syncDrawer() {
    return fetch(window.routes.cart_url + '.js', { headers: { Accept: 'application/json' } })
      .then(function (response) {
        return response.json();
      })
      .then(function (cart) {
        var lines = document.querySelectorAll('#CartDrawer .cart-item:not([data-st-gift-pending])').length;
        if (cart.item_count !== renderedItemCount() || cart.items.length !== lines) {
          return refreshDrawer().then(function () {
            if (!fixing) fixCart(cart);
          });
        }
        if (!fixing) fixCart(cart);
      })
      .catch(function () {});
  }

  var watching = false;

  function watchDrawer() {
    if (watching) return;
    var drawer = document.querySelector('cart-drawer');
    if (!drawer || !window.MutationObserver) return;
    watching = true;

    var wasActive = drawer.classList.contains('active');

    new MutationObserver(function () {
      var isActive = drawer.classList.contains('active');
      if (isActive && !wasActive) {
        wasActive = true;
        // Der Add-Request der App kann beim Öffnen noch laufen – mehrfach prüfen.
        syncDrawer();
        setTimeout(syncDrawer, 700);
        setTimeout(syncDrawer, 1800);
      } else if (!isActive) {
        wasActive = false;
      }
    }).observe(drawer, { attributes: true, attributeFilter: ['class'] });
  }

  document.addEventListener('DOMContentLoaded', function () {
    restoreDiscountState();
    watchDrawer();
    // Pubsub-Skripte sind erst hier sicher geladen (alle defer).
    watchCartUpdates();
    checkCart();
    watchLoadingEnd();
  });

  restoreDiscountState();
  watchDrawer();
})();
